// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"0352d447e023f73e18de","873":"4623e6b0331a0af4fa5b"}[chunkId] + ".js";
};